import { InlineSkeleton } from '@mindtickle/skeleton';

import {
  SITE_THUMBNAIL_STYLES,
  SITE_INFO_STYLES,
  StyledGlobalHeaderLoader,
  SETTINGS_ACTION_STYLE,
} from './styles';

const LogoLoader = () => (
  <div className="logo-wrp">
    <InlineSkeleton style={SITE_THUMBNAIL_STYLES} />
    <InlineSkeleton style={SITE_INFO_STYLES} />
    <InlineSkeleton style={SITE_INFO_STYLES} />
  </div>
);

export const SettingActionLoader = () => <InlineSkeleton style={SETTINGS_ACTION_STYLE} />;

const GlobalHeaderLoader = () => (
  <StyledGlobalHeaderLoader>
    <LogoLoader />
    <div className="settings-wrp">
      <SettingActionLoader />
      <SettingActionLoader />
      <SettingActionLoader />
      <SettingActionLoader />
    </div>
  </StyledGlobalHeaderLoader>
);

export default GlobalHeaderLoader;
